import React, { useContext, useEffect } from 'react'
import Layout from '../components/layout'
import { graphql } from 'gatsby'
import SEO from '../components/seo'
import { injectIntl } from 'gatsby-plugin-intl'
import { richTextOptions as options } from 'utils/utils'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'
import styled from 'styled-components'
import { GlobalStateContext } from '../context/globalContext'
import { GlobalDispatchContext } from '../context/globalContext'

export default injectIntl( props => {

    const state = useContext(GlobalStateContext)
    const dispatch = useContext(GlobalDispatchContext)  
     
    useEffect(() => {
        if(state.otherLanguageSlug !== props.pageContext.otherLanguageSlug) {
            dispatch(state.changeOtherLanguageSlug(props.pageContext.otherLanguageSlug))
        }
    }, [state, dispatch, props.pageContext.otherLanguageSlug])
  
    const { data, seo, listBlockSection } = props.data.contentfulSection
    
    return (
        <Layout>
            <SEO 
                title={seo.title}
                keywords={seo.attributes[0].keywords}
                slug={seo.slug}
                description={seo.attributes[0].description}
                lang={props.pageContext.language}
            />
            <Container>
                <h1>{data.content4}</h1>
                <span>{data.content5}</span>
            </Container>
            <Container>
                <Accordion allowZeroExpanded={true} preExpanded={["item_1"]}>                    
                        {
                            listBlockSection.map((section, index) => {
                                return (
                                    <AccordionItem key={index} uuid={"item_" + (index + 1)}>
                                        <AccordionItemHeading key={index}>
                                            <AccordionItemButton>
                                                {section.title}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            { documentToReactComponents(section.text && section.text.json, options) }
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                )
                            })
                        }
                </Accordion>
            </Container>
        </Layout>
    )
})

const Container = styled.main`
    margin: 7rem 2rem 2rem 2rem;
    h1 {
        font-size: 3rem;
        font-weight: bold;
    }
    span {
        display: inline-block;
        margin-top: 1rem;
    }
    li {
        list-style: disc;
    }
`
export const query = graphql`
query($language: String) {
  contentfulSection(name: {eq: "Legal"}, node_locale: {eq: $language}) {
    title
    data {
        content1
        content2
        content3
        content4
        content5
    }
    listBlockSection {
        id
        title
        text {
            json
        }
    }
    seo {
        title
        slug
        attributes {
            description
            keywords
        }
    }
  }
}`